import React, { Fragment } from 'react';
import Grid from '@mui/material/Grid';
import MuiLink from '@mui/material/Link';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import type { Link as LinkType } from '../types/form';

type Props<T> = {
  field: LinkType;
  item: T;
};

function Link<T>({ field, item }: Props<T>) {
  const hasPlaceHolder = field.link.includes('${itemFieldKey}');
  const itemValue = item[field.itemFieldKey as keyof T];

  if (
    hasPlaceHolder &&
    (field.itemFieldKey === undefined ||
      itemValue === undefined ||
      (typeof itemValue === 'string' && itemValue.trim().length === 0))
  ) {
    return (
      <Fragment key={field.key}>
        <Grid item xs={field.xsWidth != null ? field.xsWidth : 6} />
      </Fragment>
    );
  }

  const link = field.link.replace('${itemFieldKey}', `${itemValue}`);

  return (
    <Fragment key={field.key}>
      <Grid item xs={field.xsWidth != null ? field.xsWidth : 6}>
        <MuiLink href={link} display='flex' flexDirection='row' alignItems='center' target='_blank' gap={1} pt={2.5}>
          <OpenInNewIcon fontSize='small' color={link.length > 0 ? 'primary' : 'disabled'} />
          {field.label}
        </MuiLink>
      </Grid>
    </Fragment>
  );
}

export default Link;
